import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './ghs-static-header.css.lit';
import { SlotController } from '../../controllers/slot-controller';

/**
 * Pager Component
 * @element ghs-static-header
 */
@customElement('ghs-static-header')
export class GhsStaticHeader extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  slots = new SlotController(this, true);

  render(): TemplateResult {
    return html` <slot></slot> `;
  }
}
